import { ERequestSubmitted, IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { useOnbPartnerForm } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/hooks/useOnbPartnerForm'
import { IPartnerDataFormData } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/models'
import { OnbPartnerForm } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/OnbPartnerForm'
import { useCallback, useMemo, useState } from 'react'

import { PartnerStatus } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { Button } from 'core-components/library/button'
import { LoaderOverlay } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'

import { Apollo } from './components/apollo/Apollo'
import { ReactivateProcessingWindows } from './components/reactivateDialog/ReactivateProcessingWindows'

import styles from './RequestDetailPartnerForm.module.scss'

interface IPartnerDataFormProps extends IPartnerDataFormData {
  isDisabled: boolean
  onboardingRequestId: number
  appSource: string
  request: IRequest
}

export const RequestDetailPartnerForm = ({
  partner,
  partnerAttachments,
  partnerFlags,
  isDisabled,
  onboardingRequestId,
  appSource,
  request,
}: IPartnerDataFormProps) => {
  const [wip, setWip] = useState(false)
  const [reactivateStatus, setReactivateStatus] = useState<PartnerStatus | null>(null)
  const [isReactivateDialogVisible, setIsReactivateDialogVisible] = useState(false)
  const [apolloPartner, setApolloPartner] = useState<IPartner | null>(null)

  const { isFormChanged, actualData, isInactive, isLoading } = useOnbPartnerForm({
    isDisabled,
    partnerAttachments,
    onboardingRequestId,
    partner,
    partnerFlags,
    appSource,
  })

  const updateReactivateStatus = useCallback(
    (val: PartnerStatus) => {
      setReactivateStatus(val)
      if (apolloPartner) {
        apolloPartner.status = val
        setApolloPartner(apolloPartner)
      }
    },
    [apolloPartner]
  )

  const reactivateDialogContentProps = useMemo(
    () => ({
      onClose: () => setIsReactivateDialogVisible(false),
      locationId: apolloPartner?.locationId,
      request,
      updateReactivateStatus,
    }),
    [apolloPartner?.locationId, request, updateReactivateStatus]
  )

  return (
    <div className={styles.root}>
      <LoaderOverlay show={isLoading || wip} />
      <div className={styles.btns}>
        <Apollo
          request={request}
          partner={actualData.partner}
          changeWip={setWip}
          isFormChanged={isFormChanged}
          apolloPartner={apolloPartner}
          setApolloPartner={setApolloPartner}
          setIsReactivateDialogVisible={setIsReactivateDialogVisible}
        />
        {request.Region === 'AMS' &&
        (request.Submitted === ERequestSubmitted.online ||
          request.Submitted === ERequestSubmitted.rcs) ? (
          <Button
            className={styles.createProfilingTicketButton}
            disabled={isDisabled || !!reactivateStatus}
            onClick={() => setIsReactivateDialogVisible(true)}
          >
            Activate
          </Button>
        ) : null}
      </div>
      <OnbPartnerForm
        partner={actualData.partner}
        isDisabled={isDisabled}
        isInactive={isInactive}
        isLoading={isLoading}
      />
      <ModalDialog
        size={'sm'}
        show={isReactivateDialogVisible}
        closeOnOutsideClick={false}
        content={ReactivateProcessingWindows}
        contentProps={reactivateDialogContentProps}
        onClose={() => setIsReactivateDialogVisible(false)}
      />
    </div>
  )
}
